// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__37VhK","table-row-title":"Table_table-row-title__10CKT","table-row":"Table_table-row__3ONJs"};